var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "designer-mobile-toolbar" }, [
    _vm.checkIfFontHasBold
      ? _c("div", [
          _c(
            "button",
            {
              staticClass: "button button-bold",
              class: _vm.currentDesign.fontBold ? "active" : "",
              attrs: { type: "button", title: _vm.languageStrings.bold },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  ;(_vm.currentDesign.fontBold = !_vm.currentDesign.fontBold),
                    _vm.handleSelectChange()
                },
              },
            },
            [
              _c("span", { staticClass: "button-badge" }, [_vm._v("B")]),
              _vm._v(" "),
              _vm.languageStrings.bold
                ? _c("span", { staticClass: "is-sr-only" }, [
                    _vm._v(_vm._s(_vm.languageStrings.bold)),
                  ])
                : _vm._e(),
            ]
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.checkIfFontHasItalic
      ? _c("div", [
          _c(
            "button",
            {
              staticClass: "button button-italic",
              class: _vm.currentDesign.fontItalic ? "active" : "",
              attrs: { type: "button", title: _vm.languageStrings.italic },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  ;(_vm.currentDesign.fontItalic =
                    !_vm.currentDesign.fontItalic),
                    _vm.handleSelectChange()
                },
              },
            },
            [
              _c("span", { staticClass: "button-badge" }, [_vm._v("I")]),
              _vm._v(" "),
              _vm.languageStrings.italic
                ? _c("span", { staticClass: "is-sr-only" }, [
                    _vm._v(_vm._s(_vm.languageStrings.italic)),
                  ])
                : _vm._e(),
            ]
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", [
      _c(
        "button",
        {
          staticClass: "button button-uppercase",
          class: _vm.currentDesign.uppercase ? "active" : "",
          attrs: { type: "button", title: _vm.languageStrings.uppercase },
          on: {
            click: function ($event) {
              $event.preventDefault()
              ;(_vm.currentDesign.uppercase = !_vm.currentDesign.uppercase),
                _vm.handleSelectChange()
            },
          },
        },
        [
          _c("span", { staticClass: "is-sr-only" }, [
            _vm._v(_vm._s(_vm.languageStrings.uppercase)),
          ]),
        ]
      ),
    ]),
    _vm._v(" "),
    _c("div", [
      _c(
        "button",
        {
          staticClass: "button button-delete",
          attrs: { type: "button", title: _vm.languageStrings.clear_design },
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.clearDesignTrigger.apply(null, arguments)
            },
          },
        },
        [
          _vm.languageStrings.clear_design
            ? _c("span", { staticClass: "is-sr-only" }, [
                _vm._v(_vm._s(_vm.languageStrings.clear_design)),
              ])
            : _vm._e(),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }